import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Permission, Platform as TenantPlatform } from 'src/app/shared/enums/generated.enums';
import { SubPageType } from 'src/app/shared/enums/page-type.enum';
import { TenantsService } from 'src/app/shared/services/tenants.service';
import { ContactUsModalComponent } from '../../../shared/components/_modals/contact-us-modal/contact-us-modal.component';
import { ModalService } from '../../../shared/services/modal.service';

@Component({
  selector: 'app-rpa-not-connected',
  templateUrl: './rpa-not-connected.component.html',
  styleUrls: ['./rpa-not-connected.component.scss'],
  standalone: false,
})
export class RpaNotConnectedComponent implements OnInit {
  displayNavToSettings: boolean;

  get platformName(): TenantPlatform | null {
    const tenantId = this.tenantService.tenants?.length > 1 ? this.tenantService.selectedTenant?.id : this.tenantService.tenants[0]?.id;
    return this.tenantService.getTenantPlatform(tenantId);
  }

  constructor(
    private modalService: ModalService,
    private navigationService: NavigationService,
    private authService: AuthService,
    private tenantService: TenantsService,
  ) { }

  ngOnInit(): void {
    const isSystemAdmin = this.authService.hasPermission(Permission.SystemAdmin);
    const isOrgAdmin = this.authService.hasPermission(Permission.OrganizationSettings) ?? false;
    this.displayNavToSettings = isOrgAdmin || isSystemAdmin;
  }

  async navToSettings(): Promise<void> {
    // Navigate to the settings page to establish a connection
    await this.navigationService.navigateToOrganizationSettings(SubPageType.TenantsSettings);
  }

  openContactSupportModal(): void {
    this.modalService.open(ContactUsModalComponent);
  }
}
